package org.matthewo.pages.event.tabs.games

import csstype.PropertiesBuilder
import emotion.react.css
import org.matthewo.api.MetricsDecodeAPI
import org.matthewo.schema.games.DecodeScoreDetails.Classification
import org.matthewo.schema.games.DecodeScoreDetails.Classification.*
import org.matthewo.schema.games.pattern
import org.matthewo.styles.gridColumns
import react.FC
import react.Props
import react.PropsWithClassName
import react.dom.html.ReactHTML.div
import react.useMemo
import web.cssom.*

external interface DecodeMatchResultProps : Props {
    var red: MetricsDecodeAPI<Short>
    var blue: MetricsDecodeAPI<Short>
}

val DecodeMatchResult = FC<DecodeMatchResultProps>("Decode Match Result") { props ->
    val redDetails = props.red.details ?: return@FC
    val blueDetails = props.blue.details ?: return@FC
    val motif = useMemo(redDetails.randomization) { pattern(redDetails.randomization) }
    div {
        css {
            display = Display.grid
            gridTemplateColumns = repeat(2, 1.fr)
            gridTemplateRows = repeat(3, 1.fr)
        }
        div {
            css {
                gridColumns = 1..-1
                display = Display.grid
                gridTemplateColumns = array(7.5.fr, 1.fr, 1.fr, 1.fr, 7.5.fr)
                gridTemplateRows = 1.fr
            }
            motif.take(3).forEachIndexed { i, c ->
                Artifact {
                    css {
                        gridColumns = (i + 2)..(i + 3)
                    }
                    classification = c
                    wrong = false
                }
            }
        }
        [
            redDetails.asPattern,
            blueDetails.asPattern,
            redDetails.esPattern,
            blueDetails.esPattern,
        ].forEach { p ->
            Pattern {
                this.motif = motif
                pattern = p
            }
        }
    }
}

private external interface PatternProps : Props {
    var motif: List<Classification>
    var pattern: List<Classification>
}

private val Pattern = FC<PatternProps>("Pattern") { props ->
    div {
        css {
            display = Display.grid
            gridTemplateColumns = repeat(9, 1.fr)
            gridTemplateRows = array(1.fr)
        }
        props.motif.zip(props.pattern) { m, c ->
            Artifact {

                classification = c
                wrong = NONE != m && NONE != c && m != c
            }
        }
    }
}

private external interface ArtifactProps : PropsWithClassName {
    var classification: Classification
    var wrong: Boolean
}

private val Artifact = FC<ArtifactProps>("Artifact") { props ->
    div {
        css(props.className) {
            position = Position.relative
            aspectRatio = number(1.0)
            borderRadius = 50.pct
            background = when (props.classification) {
                PURPLE -> NamedColor.purple
                GREEN -> NamedColor.green
                NONE -> Globals.unset
            }

            if (props.wrong) {
                before {
                    cross()
                    transform = array(translate(-50.pct, -50.pct), rotate(45.deg))
                }
                after {
                    cross()
                    transform = array(translate(-50.pct, -50.pct), rotate(135.deg))
                }
            }
        }
    }
}

private fun PropertiesBuilder.cross() {
    display = Display.block
    position = Position.absolute
    content = string("''")
    top = 50.pct
    left = 50.pct
    width = 120.pct
    height = 10.pct
    borderRadius = 10.em
    background = NamedColor.red
}
